import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-list-years',
  templateUrl: './skeleton-list-years.component.html',
  styleUrls: ['./skeleton-list-years.component.scss']
})
export class SkeletonListYearsComponent implements OnInit {
  readonly itemsSkeleton = [1, 2];
  constructor() { }

  ngOnInit() {
  }

}
